import { useQuery } from '@tanstack/react-query'

import { configClientModuleInstance } from '@/modules/configClientModules'
import { usePatientContext } from '@/ui/contexts/PatientContext'

export function useGetModulesConfigQuery() {
  const { patient } = usePatientContext()
  const patientId = patient?.id

  return useQuery({
    queryKey: ['modulesConfig', patientId],
    queryFn: async () =>
      await configClientModuleInstance.getModuleConfig.getAllModulesConfig(
        patientId!
      ),
    enabled: !!patientId
  })
}
